import React from 'react';
import EmailCapture from './EmailCapture.js';

export default function FinalCta() {
  return (
    <section className="final-cta" id="reserve">
      <div className="shell">
        <div className="final-cta-inner">
          <h2 className="final-cta-title">Stop guessing what your gut wants. Ask it directly.</h2>
          <p className="final-cta-body">
            Kits ship weekly. Results in about three weeks, with a care scientist on the call when they land.
          </p>
          <EmailCapture variant="dark" />
          <p className="mono-label email-fineprint">No spam. One email when your kit ships.</p>
        </div>
      </div>
    </section>
  );
}
